import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-trans-debit-card',
  templateUrl: './trans-debit-card.component.html',
  styleUrls: ['./trans-debit-card.component.css']
})
export class TransDebitCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/transaction-history/trans-debit-card/trans-debit-card.component.ts